import { Routes,ActivatedRouteSnapshot, RouterModule ,ActivatedRoute} from '@angular/router';

import { LoginComponent } from './login.component';
import { ForgotComponent } from './forgot/forgot.component';
import { ResetComponent } from './reset/reset.component';
import { AuthComponent } from './auth/auth.component';




const routes: Routes = [
  { path: 'login/:messageid', component: LoginComponent },
  { path: 'forgot', component: ForgotComponent },
  { path: 'reset', component: ResetComponent },
  { path: 'auth', component: AuthComponent },
  

]

export const routing = RouterModule.forChild(routes);


// WEBPACK FOOTER //
// /Volumes/Projects/dev2/ng2fb-bootstrap/src/app/+login/login.routes.ts